export const DEFAULT_AXIS_LINE_COLOR = '#868687';

// ooxml里未体现的一些值，这些是经过尝试得出的比较合适的值
export const defaultValues = {
    // 默认的标题上下边距，在标题占位的情况下，图表plotArea会被挤压
    TITLE_MARGIN: 20,
    // 默认的g2坐标轴文本与坐标轴的间距之上，增加的额外Offset，用于接近office的默认边距
    AXIS_LABEL_APPEND_OFFSET: 10,
    LABEL_SEPARATOR: ', ',
    AXIS_SUB_TICK_LINE_LENGTH: 4,
    AXIS_TICK_LINE_LENGTH: 6,
    AXIS_OUTER_PADDING: 15,
    AXIS_LABEL_OFFSET: 100,
};
